module.exports = __webpack_public_path__ + "static/media/rights.895c255f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/rights.svg
// module id = 274
// module chunks = 0